"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = Checkbox;
var _polished = require("polished");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Field = require("../Field");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
//
// Styled components
// -------------------------------------------------------------------------------------------------
const Input = _styledComponents.default.input``;
const Label = _styledComponents.default.label``;
const Text = _styledComponents.default.span`
  color: ${p => p.theme.colors.independence};
  font-family: ${p => p.theme.fonts.robotoMono};
  font-size: ${(0, _polished.rem)(13)};
  font-weight: 500;
  letter-spacing: ${(0, _polished.rem)(0.43)};
  opacity: 0.75;
  padding-left: ${p => (0, _polished.rem)(p.theme.spacing[0])}};
`;

//
// Main component
// -------------------------------------------------------------------------------------------------
function Checkbox({
  value,
  ...props
}) {
  const {
    checked = value,
    disabled = false,
    id,
    name,
    label,
    testID
  } = props;
  const {
    onBlur,
    onChange
  } = props;

  /**
   * If we're inside of a `<Field>` component, we can use its generated ID from its context.
   */
  const fieldId = (0, _Field.useField)();
  const Base = label ? Label : _react.Fragment;
  return /*#__PURE__*/_react.default.createElement(Base, null, /*#__PURE__*/_react.default.createElement(Input, {
    checked: checked,
    "data-testid": testID,
    disabled: disabled,
    id: id || fieldId // The passed-in `id` should always take precedence.
    ,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    type: "checkbox",
    value: "true"
  }), label && /*#__PURE__*/_react.default.createElement(Text, null, label));
}